import { ModalOpenButton, RichTextEditor } from "@msys/ui";
import { Help as HelpIcon } from "@mui/icons-material";
import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ContentState, convertToRaw } from "draft-js";
import React from "react";
import { QuoteTextsAvailableReplacementsModal } from "./modals/QuoteTextsAvailableReplacementsModal.js";

interface Props {
  canEdit?: boolean;
  content?: string | undefined | null;
  readViewContent?: string | undefined | null;
  onSave?: (variables: any) => Promise<void>;
  showInfo: boolean;
  renderEditIconButton?: (button: React.ReactNode) => React.ReactNode;
}
export const OpeningTextInput = ({
  canEdit = true,
  content,
  readViewContent,
  onSave,
  showInfo,
  renderEditIconButton,
}: Props) => {
  const { t } = useTranslate([
    "QuoteDetailsForm",
    "Global",
    "OrganisationSettings",
  ]);

  return (
    <Paper>
      <Box p={2}>
        <RichTextEditor
          label={t("Opening text", {
            ns: "QuoteDetailsForm",
          })}
          content={
            content
              ? JSON.parse(content)
              : convertToRaw(ContentState.createFromText(""))
          }
          readViewContent={
            readViewContent ? JSON.parse(readViewContent) : undefined
          }
          onSave={
            onSave
              ? content => onSave({ opening: JSON.stringify(content) })
              : undefined
          }
          canEdit={canEdit}
          saveButtonLabel={t("Save", {
            ns: "Global",
          })}
          cancelButtonLabel={t("Cancel", {
            ns: "Global",
          })}
          renderEditIconButton={renderEditIconButton}
          InfoButton={
            showInfo ? (
              <ModalOpenButton
                Modal={QuoteTextsAvailableReplacementsModal}
                modalProps={{}}
              >
                <IconButton size="small" color="secondary">
                  <Tooltip
                    title={t("Available replacements", {
                      ns: "OrganisationSettings",
                    })}
                  >
                    <HelpIcon />
                  </Tooltip>
                </IconButton>
              </ModalOpenButton>
            ) : undefined
          }
        />
      </Box>
    </Paper>
  );
};
